const loadAudio = (audioFile) => {
  const audio = new Audio();
  return new Promise((resolve) => {
    audio.addEventListener('canplaythrough', () => resolve(audio), false);
    // this mysteriously fixes a mysterious bug in chrome where canplaythrough events aren't fired
    // if the setTimeout is removed or even set to 0, the canplaythrough event would sometimes not
    // be fired for all files
    setTimeout(() => { }, 10000);
    audio.src = audioFile;
    audio.load();
  });
};

const audioPlaylist = audios =>
  Promise.all(
    audios.map(audio => loadAudio(audio)),
  ).then((loadedAudios) => {
    let index = 0;
    const play = () => {
      loadedAudios[index].play();
      index = (index + 1) % loadedAudios.length;
    };
    return new Promise(resolve => resolve(play));
  });

export default audioPlaylist;
export { loadAudio };
